export default "__VITE_PUBLIC_ASSET__24207f5c__"